<template>
  <div class="navigation-panel">
    <DashboardNavigationDropdown
      class="dropdown-button"
      data-testid="dashboard-nav-dropdown"
      :dashboard-nav-links="dashboardNavLinks"
      v-bind="$attrs"
      @tracking-event="$emit('tracking-event', $event)"
    />
    <InsightsNavigationDropdown
      class="dropdown-button ml-3"
      data-testid="reporting-nav-dropdown"
      :reporting-nav-links="reportingNavLinks"
      v-bind="$attrs"
      @tracking-event="$emit('tracking-event', $event)"
    />
    <CreateDraftDropdown
      class="dropdown-button ml-3"
      data-testid="create-draft-dropdown"
      :ats-create-url="atsCreateUrl"
      :template-list="templateList"
      :modals="modals"
      @set-modal="$emit('set-modal', $event)"
      @tracking-event="$emit('tracking-event', $event)"
    />
  </div>
</template>

<script>
import DashboardNavigationDropdown from '@/components/shared/DashboardNavigationDropdown.vue';
import CreateDraftDropdown from '@/components/shared/CreateDraftDropdown.vue';
import InsightsNavigationDropdown from '@/components/shared/InsightsNavigationDropdown.vue';

export default {
  name: 'NavigationPanel',
  components: {
    DashboardNavigationDropdown,
    CreateDraftDropdown,
    InsightsNavigationDropdown,
  },
  props: {
    atsCreateUrl: { type: String, default: '' },
    modals: { type: Object, default: () => ({}) },
    templateList: { type: Array, default: () => [] },
    reportingNavLinks: { type: Array, default: () => [] },
    dashboardNavLinks: { type: Array, default: () => [] },
  },
  emits: ['set-modal', 'tracking-event'],
};
</script>
<style scoped lang="less">
.navigation-panel {
  display: flex;
  :deep(.dropdown-button) {
    a {
      color: @text-darkest;
      text-decoration: none;
    }
    &.open a, &.dropdown-open a {
      color: @text-brand;
    }
  }
}
</style>
